module.exports = __webpack_public_path__ + "img/EN-PLC-3.1caf77e1.png";